export enum ErrorEnum {
  PURCHASE_ERROR,
  FETCH_PRODUCTS_ERROR,
  PURCHASE_TRANSACTION_ERROR,
}

export enum ModalType {
  BuyMore = 'BuyMore',
}
